var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "67.000000pt",
    height: "65.000000pt",
    viewBox: "0 0 67.000000 65.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,65.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 560 c-16 -16 -25 -33 -22 -37 4 -4 13 -1 19 5 7 7 16 12 20 12 4 0 8 -101 8 -225 l0 -225 227 0 c222 0 226 0 209 -19 -31 -34 0 -31 32 2 l32 33 -34 33 c-36 35 -63 26 -30 -10 17 -19 15 -19 -197 -17 l-214 3 -3 213 c-1 116 1 212 6 212 4 0 13 -5 20 -12 6 -6 15 -9 19 -5 6 7 -45 67 -57 67 -3 0 -19 -13 -35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 453 c9 -37 60 -120 97 -160 l31 -32 -34 -20 c-19 -12 -51 -26 -71 -33 -21 -6 -38 -17 -38 -24 0 -17 43 -4 108 31 l48 26 65 -30 c35 -17 72 -31 82 -31 31 0 18 19 -20 29 -21 6 -53 20 -72 31 l-33 21 36 35 c56 54 120 174 93 174 -6 0 -20 -21 -31 -46 -10 -25 -41 -69 -67 -97 l-49 -52 -39 44 c-21 23 -51 70 -66 102 -30 61 -52 79 -40 32z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupply);
export default __webpack_public_path__ + "static/media/supply.bf6c85dc90e562208015f813923d55df.svg";
export { ForwardRef as ReactComponent };